<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.7603 21.7702H19.5V13.9215H26.7603V8.91588C26.7603 7.9074 26.0082 7.08984 25.0802 7.08984H2.68001C1.753 7.08984 1 7.9074 1 8.91588V27.1742C1 28.1826 1.753 29.0002 2.68001 29.0002H25.0802C26.0082 29.0002 26.7603 28.1826 26.7603 27.1742V21.7702ZM5.38038 20.056H14.6204V15.744H5.38038V20.056Z"
      fill="#040A34"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.68001 8.08984C2.38182 8.08984 2 8.37992 2 8.91588V27.1742C2 27.7101 2.38181 28.0002 2.68001 28.0002H25.0802C25.3791 28.0002 25.7603 27.7105 25.7603 27.1742V22.7702H19.5C18.9477 22.7702 18.5 22.3225 18.5 21.7702C18.5 21.2179 18.9477 20.7702 19.5 20.7702H26.7603C27.3125 20.7702 27.7603 21.2179 27.7603 21.7702V27.1742C27.7603 28.6548 26.6374 30.0002 25.0802 30.0002H2.68001C1.12419 30.0002 0 28.6552 0 27.1742V8.91588C0 7.43489 1.12419 6.08984 2.68001 6.08984H25.0802C26.6374 6.08984 27.7603 7.43528 27.7603 8.91588V13.9215C27.7603 14.4738 27.3125 14.9215 26.7603 14.9215H19.5C18.9477 14.9215 18.5 14.4738 18.5 13.9215C18.5 13.3692 18.9477 12.9215 19.5 12.9215H25.7603V8.91588C25.7603 8.37952 25.3791 8.08984 25.0802 8.08984H2.68001Z"
      fill="#040A34"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.88 21.6976H22.28C20.4239 21.6976 18.9199 20.0636 18.9199 18.0466C18.9199 16.0296 20.4239 14.3945 22.28 14.3945H27.88C28.499 14.3945 29 14.9392 29 15.6123V20.481C29 20.8035 28.882 21.113 28.672 21.3417C28.462 21.5704 28.177 21.6976 27.88 21.6976Z"
      stroke="#040A34"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.3246 7.08464L20.0616 2.82422L13.2715 7.08464"
      stroke="#040A34"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.4319 4.47735L15.5839 1L5.88477 7.08646"
      stroke="#040A34"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
